import { App } from "vue";
import { DynamicScroller, DynamicScrollerItem, RecycleScroller } from "vue3-virtual-scroller";
import "vue3-virtual-scroller/dist/vue3-virtual-scroller.css";

// export default vue3-virtual-scroller
export default (app: App<Element>): void => {
  // Add common components of virtual scroller
  app.component("DynamicScroller", DynamicScroller);
  app.component("DynamicScrollerItem", DynamicScrollerItem);
  app.component("RecycleScroller", RecycleScroller);
};
